import {
  Component,
  Inject,
  Optional,
  OnDestroy,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';

@Component({
  selector: 'app-municion-recomendada',
  templateUrl: './municion-recomendada.component.html',
  styleUrls: ['./municion-recomendada.component.scss'],
})
export class MunicionRecomendadaComponent
  implements OnDestroy, AfterViewInit, OnInit
{
  constructor(
    @Optional() public dialogRef: MatDialogRef<MunicionRecomendadaComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private snackBarService: SnackBarService,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {}

  ngOnDestroy() {}

  close() {
    this.dialogRef.close();
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje, 10000);
  }
}
